import React from 'react';

import { PreferencesFlexibility } from '../components/Preferences/PreferencesFlexibility';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export type WorkStylePreferencesPageProps = {
  name?: string;
};

export const WorkStylePreferencesPage = ({
  name = 'WORK_STYLE_PREFERENCES_PAGE',
}: WorkStylePreferencesPageProps) => {
  useDocumentTitle('Preferences');
  return (
    <div data-test={name}>
      <PreferencesFlexibility />
    </div>
  );
};
